<div class="product-cards-section">
  <div class="axs-flex-inner-wrapper">
    <h2 class="weight-bold text-650 axs-lg-offset-left-1 axs-lg-offset-right-1">{{ productCardsContent?.productHeader }}</h2>
    <div class="product-cards axs-lg-offset-left-1 axs-lg-offset-right-1">
      <div class="product-card">
        <div class="product-card__header">
          <div class="product-card__guide"></div>
          <div class="product-card__header__text">{{ productCardsContent?.productTitle1 }}</div>
        </div>
        <div class="product-card__subtext">{{ productCardsContent?.productDesc1 }}</div>
        <div class="product-card__button">
          <ngx-axs-button
            axsType="primary"
            axsText="{{ productCardsContent?.productButton1 }}"
            axsLink="{{ productLinks.modelPortfolios }}"
            axsSize="medium"
            axsTheme="black"
            [axsShowIcon]="true"
            axsIconType="arrowRight"
            [axsOpenInNewTab]="true"
            (axsClick)="adobeTaggingCTAEvent('banner:explore-models')">
          </ngx-axs-button>
        </div>
      </div>

      <div class="product-card">
        <div class="product-card__header">
          <div class="product-card__guide"></div>
          <div class="product-card__header__text">{{ productCardsContent?.productTitle2 }}</div>
        </div>
        <div class="product-card__subtext">{{ productCardsContent?.productDesc2 }}</div>
        <div class="product-card__button">
          <ngx-axs-button
            axsType="primary"
            axsText="{{ productCardsContent?.productButton2 }}"
            axsLink="{{ productLinks.equityInvestments }}"
            axsSize="medium"
            axsTheme="black"
            [axsShowIcon]="true"
            axsIconType="arrowRight"
            [axsOpenInNewTab]="true"
            (axsClick)="adobeTaggingCTAEvent('banner:view-products')">
          </ngx-axs-button>
        </div>
      </div>

      <div class="product-card">
        <div class="product-card__header">
          <div class="product-card__guide"></div>
          <div class="product-card__header__text">{{ productCardsContent?.productTitle3 }}</div>
        </div>
        <div class="product-card__subtext">{{ productCardsContent?.productDesc3 }}</div>
        <div class="product-card__button">
          <ngx-axs-button
            axsType="primary"
            axsText="{{ productCardsContent?.productButton3 }}"
            axsLink="{{ productLinks.personalizedIndexing }}"
            axsSize="medium"
            axsTheme="black"
            [axsShowIcon]="true"
            axsIconType="arrowRight"
            [axsOpenInNewTab]="true"
            (axsClick)="adobeTaggingCTAEvent('banner:explore-VPI')">
          </ngx-axs-button>
        </div>
      </div>
    </div>
  </div>
</div>
